<template>
  <div class="add-ciec-loading is-flex is-centered">
    <img
      src="../../../assets/img/ciec-loading.svg"
      alt="loading ciec illustration"
    >

    <h1 class="title is-2 has-text-primary">
      Validando CIEC
    </h1>

    <h2 class="title is-4 has-text-primary">
      Esto puede durar varios segundos...
    </h2>

    <h2 class="title is-4 has-text-primary">
      Puedes seguir ocupando la plataforma mientras se valida la CIEC.
    </h2>

    <b-loading
      :is-full-page="false"
      active
    />
  </div>
</template>

<script>
export default {
  name: 'AddCIECLoading',
};
</script>

<style scoped>
.add-ciec-loading.is-flex.is-centered {
  flex-direction: column;
  position: relative;
}
</style>

<style>
.add-ciec-loading.is-flex.is-centered .loading-overlay .loading-background {
  display: none;
}
</style>
